import { Tab, TabList, TabProvider, dashboardMenu } from "@replicate/ui";

export default function DashboardNavigation({
  selected = "dashboard",
}: { selected?: string }) {
  return (
    <>
      <TabProvider
        selectedId={selected}
        setSelectedId={(id) => {
          const targetPath = id === "dashboard" ? "/" : `/${id}`;
          if (window.location.pathname !== targetPath) {
            window.location.href = targetPath;
          }
        }}
      >
        <TabList responsive>
          {dashboardMenu.map((item) => (
            <Tab
              key={item.label}
              id={item.label.toLowerCase()}
              // biome-ignore lint/a11y/useAnchorContent: handled by ariakit
              render={<a className="no-underline" href={item.href} />}
              startIcon={item.icon}
              aria-selected={selected === item.label.toLowerCase()}
            >
              {item.label}
            </Tab>
          ))}
        </TabList>
      </TabProvider>
    </>
  );
}
